import { useAuth0 } from '@auth0/auth0-react';

export const useApiClient = () => {
  const { getAccessTokenSilently } = useAuth0();

  const baseUrl = import.meta.env.VITE_MANAGEMENT_API_URL || '';

  return {
    get: async <T>(endpoint: string, params = {}): Promise<T> => {
      const searchParams = new URLSearchParams(
        params as Record<string, string>
      ).toString();
      const url = `${baseUrl}${endpoint}${searchParams ? `?${searchParams}` : ''}`;

      try {
        const token = await getAccessTokenSilently();
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(
            `API error: ${response.status} - ${errorData?.message || response.statusText}`
          );
        }

        return response.json();
      } catch (error) {
        console.error('API request failed:', error);
        throw error;
      }
    },

    post: async <T>(endpoint: string, data = {}): Promise<T> => {
      const url = `${baseUrl}${endpoint}`;

      try {
        const token = await getAccessTokenSilently();
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'x-api-version': '1.0',
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(
            `API error: ${response.status} - ${errorData?.message || response.statusText}`
          );
        }

        return response.json();
      } catch (error) {
        console.error('API request failed:', error);
        throw error;
      }
    },
  };
};
